<template>
  <el-select
    size="small"
    v-model="selectValue"
    :placeholder="`${$t(`${placeholder}`)}`"
    :filterable="filterable"
    :clearable="clearable"
    :disabled="disabled"
    popper-class="select-tree"
    @visible-change="visibleSelectChange"
    ref="selectRef"
    @clear="selectValue = null"
    remote
    :remote-method="filterTree"
    :key="updateKey"
  >
    <el-option
      :label="selectName"
      :value="selectValue"
      :style="{ padding: 0, height: '100%', fontWeight: 'normal' }"
    >
      <el-tree
        :props="treeProps"
        class="max-h-274px overflow-x-hidden options-tree"
        ref="treeRef"
        :node-key="nodeKey || 'id'"
        highlight-current
        :data="optionList"
        @node-click="treeNodeClick"
        :expand-on-click-node="false"
        :default-expanded-keys="defaultExpandedKeys"
        :filter-node-method="filterTreeNode"
      >
        <div
          class="w-full truncate"
          slot-scope="{ node }"
          :class="{
            'cursor-not-allowed': node.disabled,
            'text-[#C0C4CC]': node.disabled,
          }"
        >
          {{ node.label }}
        </div>
      </el-tree>
    </el-option>
  </el-select>
</template>

<script>
import { find, random } from 'lodash'
import { treeToOneArray } from '@/assets/js/common/common'

export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    treeProps: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          children: 'children',
        }
      },
    },
    optionList: {
      type: Array,
      default: () => {
        return []
      },
    },
    nodeKey: {
      type: String,
      default: 'id',
    },
    filterable: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultExpandedKeys: [],
      flattenOptionList: [],
      updateKey: random(10000),
    }
  },
  computed: {
    selectName() {
      return (
        find(this.flattenOptionList, (item) => {
          return item[this.nodeKey] === this.value
        })?.[this.treeProps.label] || ''
      )
    },
    selectValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      },
    },
  },
  watch: {
    optionList: {
      immediate: true,
      handler(val) {
        this.flattenOptionList = treeToOneArray(val, this.treeProps.children)
      },
    },
    selectName() {
      this.$nextTick(() => {
        this.updateKey = random(10000)
      })
    },
  },
  methods: {
    filterTree(query) {
      this.$refs.treeRef.filter(query)
    },
    // 过滤节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data[this.treeProps.label].indexOf(value) !== -1
    },
    visibleSelectChange(boolean) {
      this.$nextTick(() => {
        if (boolean) {
          this.filterTree()
          if (this.value) {
            this.$refs.treeRef.setCurrentKey(this.value) // 设置选中元素
            this.defaultExpandedKeys = [this.value]
          }
        } else {
          const nodeDatas = this.$refs.treeRef.store.nodesMap
          _.forIn(nodeDatas, (val) => {
            val.expanded = false
          })
        }
      })
    },
    treeNodeClick(node) {
      if (node.disabled) return
      this.selectValue = node[this.nodeKey]
      this.$emit('treeNodeClick', node)
      this.$refs.selectRef.blur()
    },
  },
}
</script>

<style lang="scss" scoped>
.options-tree {
  &::-webkit-scrollbar {
    width: 6px;
  }
  ::v-deep .el-tree-node__content {
    height: 36px;
  }
}
</style>
<style lang="scss">
.select-tree {
  .el-select-dropdown__wrap {
    max-height: 100%;
  }
}
</style>
